import { mdiHelpBoxOutline } from '@mdi/js'
import Icon from '@mdi/react'

import { Box } from '@/components/ui/box'
import { IconButton } from '@/components/ui/button'
import { MenuRoot, MenuTrigger } from '@/components/ui/menu'
import useColorModeValue from '@/hooks/useColorModeValue'

import MenuList from './menuList'

const HelpCenter = () => {
    return (
        <Box mr="16px" display={['none', 'none', 'none', 'block']}>
            <MenuRoot variant="helpCenter">
                <MenuTrigger asChild>
                    <IconButton
                        aria-label="Help center"
                        icon={
                            <Icon
                                path={mdiHelpBoxOutline}
                                size="18px"
                                color={useColorModeValue('var(--chakra-colors-dark-700)', 'var(--chakra-colors-white)')}
                            />
                        }
                        variant="menu"
                        data-id="Help center"
                    />
                </MenuTrigger>
                <MenuList />
            </MenuRoot>
        </Box>
    )
}

export default HelpCenter
